// Override the mega-menu fade-out speed without editing theme.js
customElements.whenDefined('mega-menu-disclosure').then(() => {
  const MegaMenu = customElements.get('mega-menu-disclosure');

  const FADE_OUT_SECONDS = 0.1; // ← change this (theme default is 0.4)

  MegaMenu.prototype.createHideAnimationControls = function () {
    const el = this.contentElement;
    const anim = el.animate(
      { opacity: [1, 0] },
      { duration: FADE_OUT_SECONDS * 1000, easing: 'ease' }
    );
    // Commit the final state, matching the theme's behavior (inline opacity:0)
    anim.finished.then(() => { el.style.opacity = '0'; }).catch(() => {});
    return anim;
  };
});

// The sticky add-to-cart bar's "Notify Me" link is a visual stand-in shown via CSS
// (see custom-styling.css) since Klaviyo's real back-in-stock button has a fixed ID and can
// only mount once on the page. Forward clicks on the stand-in to the real widget.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.product-sticky-bar__notify-trigger');
  if (!trigger) return;
  event.preventDefault();
  document.querySelector('#klaviyo-bis-button-container [data-a11y-identifier^="bis-button-"]')?.click();
});